import { render, staticRenderFns } from "./myNotify.vue?vue&type=template&id=260cfc78&"
import script from "./myNotify.vue?vue&type=script&lang=js&"
export * from "./myNotify.vue?vue&type=script&lang=js&"
import style0 from "./myNotify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports